import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { getEnvironment } from './utils/config.js'
import './index.css'
import App from './App.jsx'

const environment = getEnvironment()

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN || 'https://5e63f3763287d7346d19d73dced99cb3@o4507816919302144.ingest.us.sentry.io/4510933326954496',
  environment,
  release: `reziland-portal@${import.meta.env.VITE_APP_VERSION || '1.0.0'}`,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: environment === 'production' ? 0.2 : 1.0,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: environment === 'production' ? 1.0 : 0,
  enabled: environment !== 'localhost',
})

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
